module.exports = __webpack_public_path__ + "static/media/teilnahme_false_active.55634cd3.jpg";